import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=53cc84dd&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=ts&"
export * from "./Settings.vue?vue&type=script&lang=ts&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=53cc84dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc84dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53cc84dd')) {
      api.createRecord('53cc84dd', component.options)
    } else {
      api.reload('53cc84dd', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=53cc84dd&scoped=true&", function () {
      api.rerender('53cc84dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings.vue"
export default component.exports